var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"z-index":"1"}},[_c('DashboardScreenSelect'),(_vm.currentState === _vm.states.Apps)?_c('AppsView'):_vm._e(),(_vm.currentState === _vm.states.Keywords)?_c('KeywordView'):_vm._e(),(_vm.currentState === _vm.states.TopCharts)?_c('TopChartsView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }